import React, { useRef, useState } from 'react'
import Layout from '../../components/Layout/Layout'
import * as styles from './index.module.css'
import { Helmet } from 'react-helmet'
import { StaticImage } from 'gatsby-plugin-image'
import profileApi from '../../services/ProfileAPI'

function ContactUs() {
  // Refs
  const usernameRef = useRef(null)
  const phoneRef = useRef(null)
  const emailRef = useRef(null)
  const messageRef = useRef(null)

  // State
  const [loading, setLoading] = useState(false)
  const [successMessage, setSuccessMessage] = useState('')

  const onSubmit = () => {
    const contactDetails = {
      username: usernameRef.current?.value.toString(),
      phone: phoneRef.current?.value.toString(),
      email: emailRef.current?.value.toString(),
      message: messageRef.current?.value.toString(),
    };

    setLoading(true)
    profileApi.contactUs(contactDetails)
      .then(res => {
        setLoading(false)
        setSuccessMessage('Thank you for reaching out! We will get back to you soon.')
      })
      .catch(err => {
        setLoading(false)
        alert(err.response.data?.message)
      });
  }

  return (
    <Layout>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Contact Us - Load&Lock</title>
      </Helmet>
      <div className={styles.contact}>
        <div className={styles.image}>
          <StaticImage
            src="../../assets/Images/logo.png"
            alt="logo"
            placeholder="blurred"
            layout="fixed"
            width={200}
          />
        </div>
        <h1>Contact Us</h1>
        {successMessage && <p className={styles.successMessage}>{successMessage}</p>}
        <div className={styles.inputField}>
          <input placeholder='Username' type='text' ref={usernameRef} />
          <input placeholder='Email' type='email' ref={emailRef} />
          <input placeholder='Phone' type='text' ref={phoneRef} />
          <textarea placeholder='Your Message' ref={messageRef} />
        </div>
        {loading ?
          <p className={styles.submitBtn}>Submitting...</p>
          :
          <p className={styles.submitBtn} onClick={onSubmit}>Submit</p>
        }
      </div>
    </Layout>
  )
}

export default ContactUs
